module.exports = {"id":"next-school-dictionary","title":"Next School Dictionary","author":"MOPTOP","style":"house","language":"en","thumbnail":"https://i.ytimg.com/vi/1jb2LaUirog/mqdefault.jpg","sections":[{"title":"Next School Dictionary","videos":[{"youtubeId":"1jb2LaUirog","duration":"PT8M3S","title":"Shuffle & Dodge, Gallop, Gallop Shuffle, Gallop Shuffle Cross (and variations)","height":270,"width":480},{"youtubeId":"7NTnGuxuToU","duration":"PT7M55S","title":"Triangle, Roger Rabbit, Diamond, Lotus (and variations)","height":270,"width":480}]}]}


//////////////////
// WEBPACK FOOTER
// ../common/js/tutorials/playlists/house/nextschool_dictionary.json
// module id = l/Jt
// module chunks = 0 1